import BrowserStorageAccessor from 'common/utils/BrowserStorageAccessor';
import { COOKIES_KEYS, SESSION_STORAGE_KEYS } from 'common/constants/constants';
import Cookies from 'js-cookie';

export const isGdprCheckboxChecked = () =>
  BrowserStorageAccessor().session.get(SESSION_STORAGE_KEYS.GDPR_CHECKBOX);
export const removeIsGdprCheckboxChecked = () =>
  BrowserStorageAccessor().session.remove(SESSION_STORAGE_KEYS.GDPR_CHECKBOX);
export const storeIsGdprCheckboxChecked = () =>
  BrowserStorageAccessor().session.set(
    SESSION_STORAGE_KEYS.GDPR_CHECKBOX,
    true
  );

export const isGdprCookieExists = () =>
  Cookies.get(COOKIES_KEYS.IS_GDPR) === 'true'; //cookie's values is always a string
export const storeIsGdprCookie = () =>
  Cookies.set(COOKIES_KEYS.IS_GDPR, 'true', { expires: 365 }); // { expires: 365 } = 1yr
export const removeIsGdprCookie = () => Cookies.remove(COOKIES_KEYS.IS_GDPR);

export const accountApprovedGdpr = () => {
  storeIsGdprCookie();
  removeIsGdprCheckboxChecked();
};

export const validateGdprAgreement = account => {
  if (!account.gdpr_consent_ts) {
    removeIsGdprCookie();
    return false;
  }
  return true;
};
